import React from 'react';
import { ReactComponent as ArrowUpRight } from '@/assets/v2/icons/arrow-up-right.svg';
import { Link } from 'gatsby';
import type { AnchorHTMLAttributes } from 'react';

type LinkArrowProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  to: string;
  children: React.ReactNode;
  color?: 'black' | 'white' | 'orange';
  size?: 'sm' | 'md' | 'xs';
};

const LinkArrow = ({
  children,
  color = 'black',
  size = 'sm',
  className,
  ...props
}: LinkArrowProps) => {
  const strokeClass =
    color === 'orange'
      ? 'stroke-orange'
      : color === 'white'
      ? 'stroke-white'
      : 'stroke-black';

  const sizeClass = size === 'md' ? 'w-6 h-6' : 'w-4 h-4';
  const translateClass =
    size === 'md'
      ? 'group-hover/link-arrow:translate-x-6 group-hover/link-arrow:-translate-y-6'
      : 'group-hover/link-arrow:translate-x-4 group-hover/link-arrow:-translate-y-4';
  const translateBackClass =
    size === 'md'
      ? '-translate-x-6 translate-y-6 group-hover/link-arrow:translate-x-0 group-hover/link-arrow:translate-y-0'
      : '-translate-x-4 translate-y-4 group-hover/link-arrow:translate-x-0 group-hover/link-arrow:translate-y-0';

  return (
    <Link
      {...props}
      className={`group/link-arrow relative flex items-center gap-1 text-${color} text-${
        size === 'xs' ? 'xs lg:sm' : size === 'sm' ? 'sm' : 'base'
      } ${className}`}
    >
      {children}
      <div className={`${sizeClass} mt-0.5 relative overflow-hidden`}>
        <ArrowUpRight
          className={`w-full h-full absolute top-0 left-0 ${translateClass} transition-all duration-300 stroke-[2] strokeLinecap-round strokeLinejoin-round ${strokeClass}`}
        />
        <ArrowUpRight
          className={`w-full h-full absolute top-0 right-0 ${translateBackClass} transition-all duration-500 stroke-[2] strokeLinecap-round strokeLinejoin-round ${strokeClass}`}
        />
      </div>
    </Link>
  );
};

export default LinkArrow;
